const breakpoints = {
  //420px
  xSmall: '(max-width: 26.25em)',
  // 640px
  small: '(max-width: 40em)',
  // 900px
  medium: '(max-width: 56.25em)',
  // 1199px
  large: '(max-width: 74.99em)',
  // 1200px
  xLarge: '(min-width: 75em)',
}

export default breakpoints 